/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCodeDownload: {
  name: 'code-download';
  data: string;
} = {
  name: 'code-download',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.64 5.232a1 1 0 0 1 .128 1.408L4.302 12l4.466 5.36a1 1 0 0 1-1.536 1.28l-4.467-5.36a2 2 0 0 1 0-2.56l4.467-5.36a1 1 0 0 1 1.408-.128ZM12 7a1 1 0 0 1 1 1v4.586l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L11 12.586V8a1 1 0 0 1 1-1Zm4.768-1.64a1 1 0 0 0-1.536 1.28L19.698 12l-4.466 5.36a1 1 0 0 0 1.536 1.28l4.467-5.36a2 2 0 0 0 0-2.56l-4.467-5.36Z" fill="currentColor"/></svg>`,
};
